import React from 'react';
import { connect } from 'react-redux';

import {
  selectTripTrailhead,
  deselectTripTrailhead,
  sidebarClose,
  toggleTraiheadsTrips,
} from '../actions';
import Sidebar from '../components/Sidebar';

const mapStateToProps = state => {
  const { tripsTrailheads, sidebar } = state;
  return {
    trailheads: tripsTrailheads.trailheads || [],
    trips: tripsTrailheads.trips || [],
    selected: tripsTrailheads.selected,
    selector: tripsTrailheads.selector,
    sidebar: sidebar.open,
    trailheadsToggled: sidebar.trailheads,
    fetchingData: tripsTrailheads.fetchingData,
  };
};

export default connect(mapStateToProps, {
  selectTripTrailhead,
  deselectTripTrailhead,
  sidebarClose,
  toggleTraiheadsTrips,
})(Sidebar);



// WEBPACK FOOTER //
// ./map/containers/SidebarConnected.js